import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import DeleteModal from "../../../components/Modal/DeleteModal";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import AddInventory from "../../../components/Modal/AddInventory";
import ListView from "../../../components/ContentDisplay/ListView";
import {getUserProfile} from "../../../redux/Selectors/users.selector";
import {InventoryCard} from "./inventoryCard";
import {StatusBadge} from "./StatusBadge";
import {
  ACTIONS_LST,
  LIST_HEADERS,
  PERMS_FOR_ACTIONS,
  SORTABLE_FIELDS,
} from "./inventoryTable.constants";
import {useInventorySearchOptions} from "./useInventorySearchOptions";
import {useInventoryTableActions} from "./useInventoryTableActions";
import {useInventoryTableData} from "./useInventoryTableData";

// Display-only: the row value stays the raw slug
const StatusCell = ({data}) => <StatusBadge status={data.status} />;

const CUSTOM_RENDER_KEYS = ["status"];

const InventoryTable = () => {
  const {fetchAfterDelete, inventories, handleSearch, paginationConfig, totalCount} =
    useInventoryTableData();
  const {searchOptions} = useInventorySearchOptions();
  const {is_superuser, is_staff} = useSelector(getUserProfile);
  // Commission Device Action should be visible only to super user or staff
  const actionsList = ACTIONS_LST.filter(
    (action) => action.label !== "Commission Device" || is_superuser || is_staff
  );
  const {
    commissionDevice,
    commissionModalStatus,
    deleteInventory,
    deleteModalStatus,
    editModalStatus,
    handleActionSelection,
    setCommissionModalStatus,
    setDeleteModalStatus,
    setEditModalStatus,
  } = useInventoryTableActions(fetchAfterDelete);

  return (
    <Fragment>
      <AddInventory
        open={editModalStatus}
        onClose={() => setEditModalStatus(false)}
        onCancel={setEditModalStatus}
        onEdit={true}
      />
      {deleteModalStatus && (
        <DeleteModal
          header={"Delete Inventory"}
          modalBody={"Are you sure you want to delete this inventory?"}
          onClose={() => setDeleteModalStatus(false)}
          onDelete={deleteInventory}
          open={deleteModalStatus}
        />
      )}
      {commissionModalStatus && (
        <ConfirmModal
          header={"Commission Device"}
          modalBody={"Are you sure you want to commission this device?"}
          onClose={() => setCommissionModalStatus(false)}
          onConfirm={commissionDevice}
          open={commissionModalStatus}
        />
      )}
      <ListView
        cardContent={InventoryCard}
        listItems={inventories}
        listHeaders={LIST_HEADERS}
        onSelectAction={handleActionSelection}
        withActions
        actionsList={actionsList}
        permsForActions={PERMS_FOR_ACTIONS}
        totalCount={totalCount}
        withPagination={paginationConfig}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Inventory"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
        sortableFields={SORTABLE_FIELDS}
        customRenderKeys={CUSTOM_RENDER_KEYS}
        customRenderComponent={StatusCell}
        tableName="inventory"
      />
    </Fragment>
  );
};

export default InventoryTable;
